<template>
    <!-- <transition name="slide-down" mode="in-out"> -->
        <div class="container" v-if="messages">
            <div class="columns">
                <div class="column is-12">
                    <div class="notification is-success">
                        <button class="delete" @click="clearAuthMessages"></button>
                        <span v-html="messages"></span>
                    </div>
                </div>
            </div>  
        </div>
    <!-- </transition> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'home',
    computed: {
        ...mapGetters({
            messages: 'auth/messages'
        }),
    },

    methods: {
        ...mapActions({
            clearAuthMessages: 'auth/clearAuthMessages',
        }),
    }
}
</script>

<style>

</style>